import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import _ from 'lodash';
import DisplayUnitActions from './display-unit-actions';

const initialState = Immutable({ byId: {}, isFetching: false, hasFetched: false });

const reducer = createReducer(on => {
  on(DisplayUnitActions.fetch, state => state.set('isFetching', true));
  on(DisplayUnitActions.fetchFailure, state => state.set('isFetching', false));
  on(DisplayUnitActions.fetchSuccess, (state, { displayUnits }) => {
    const byId = _.reduce(
      displayUnits,
      (acc, displayUnit) => {
        acc[displayUnit.id] = displayUnit;
        return acc;
      },
      {}
    );
    return state.merge({ isFetching: false, hasFetched: true, byId });
  });
  on(DisplayUnitActions.updateDisplayUnitSuccess, (state, { displayUnit }) => {
    const displayUnits = _.isArray(displayUnit) ? displayUnit : [displayUnit];
    let displayUnitsById = _.reduce(
      displayUnits,
      (acc, displayUnit) => {
        acc[displayUnit.id] = displayUnit;
        return acc;
      },
      {}
    );
    displayUnitsById = state.byId.merge(displayUnitsById);
    return state.set('byId', displayUnitsById);
  });
  on(DisplayUnitActions.removeDisplayUnit, (state, { id }) => state.set('byId', _.omit(state.byId, id)));
  on(DisplayUnitActions.add, (state, { displayUnits }) => {
    let displayUnitsById = _.reduce(
      displayUnits,
      (acc, displayUnit) => {
        acc[displayUnit.id] = displayUnit;
        return acc;
      },
      {}
    );
    displayUnitsById = state.byId.merge(displayUnitsById);
    return state.set('byId', displayUnitsById);
  });
}, initialState);

export default reducer;
